import React from "react";
import { Link } from "react-router-dom";

const SectionLayout = ({
  title,
  description,
  content,
  reverse = false,
  background = "",
  ctaText = "",
  ctaLink = "",
}) => {
  return (
    <section className={`container mx-auto px-6 py-16 ${background}`}>
      <div
        className={`flex flex-col md:flex-row ${
          reverse ? "md:flex-row-reverse" : ""
        } items-start gap-12`}
      >
        {/* Title, Description, and Optional CTA */}
        <div
          className={`w-full md:w-[40%] flex flex-col justify-between ${
            reverse ? "pr-6 md:pr-12" : "pl-6 md:pl-12"
          }`}
        >
          <div>
            <div className="inline-block">
              <h2 className="text-6xl font-bold uppercase text-primary leading-tight mb-2">
                {title}
              </h2>
              {/* Dynamic underline that matches title width */}
              <div className="border-t-2 border-primary w-full mb-6"></div>
            </div>
            <p className="text-lg text-gray-700">{description}</p>
          </div>

          {/* CTA Button - Aligned at Bottom */}
          {ctaText && ctaLink && (
            <div className="mt-8">
              <Link
                to={ctaLink}
                className="bg-primary text-white px-8 py-4 text-xl rounded-lg shadow-md transition-transform duration-300 ease-in-out  hover:font-bold "
              >
                {ctaText}
              </Link>
            </div>
          )}
        </div>

        {/* Content - Consistent Margins */}
        <div
          className={`w-full md:w-[60%] p-6 md:p-10 ${
            reverse ? "pl-6 md:pl-12" : "pr-6 md:pr-12"
          }`}
        >
          {content}
        </div>
      </div>
    </section>
  );
};

export default SectionLayout;
